import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

@withRouter
class PageNotFound extends Component{
  // componentDidMount() {
  //   this.props.history.push("/admin");
  // }
  render() {
    // return null;
    return (
      <div className="text-center"
           style={{paddingTop: 100}}>
        <h1 style={{
          fontSize: 125,
          fontWeight: 700,
          textShadow: "5px 5px 10px"
        }}>404</h1>
        <h1>Page not found</h1>
      </div>
    );
  }
}

// "proxy": {
//   "/api": {
//     "target": "https://headlinealerts.internationalsos.com",
//     "target": "http://192.168.0.54:8080",
//     "pathRewrite": {
//       "^/api": "/api"
//     },
//     "changeOrigin": true,
//       "secure": false
//   }
// }

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/component/404.js